import React from 'react';

const SelectedFormatter = (props) => {
  let icon = props.rowIdx === props.selected.rowIdx ? <div className="icon">chevron_right</div> : null;
  let title = props.rowIdx === props.selected.rowIdx ? 'True' : 'False';
  return (
    <div className="selectedicon" title={title}>
      {icon}
    </div>
  );
};

export default SelectedFormatter;
